import { useEffect } from 'react';

const useHideLocalize = () => {
  useEffect(() => {
    const localizeEl = document.querySelector('#localize-widget');
    if (localizeEl) {
      localizeEl.classList.add('hidden');
    }
    return () => {
      if (localizeEl) {
        localizeEl.classList.remove('hidden');
      }
    };
  }, []);
};

export default useHideLocalize;
